import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/css/iofrm-style.css'
import '@/css/loginForm.css'
import VueTheMask, { mask } from 'vue-the-mask';
import vMoney from 'v-money';



const app = createApp(App)

// Usando os plugins corretamente
app.use(router)
app.use(VueTheMask); // Registra a diretiva globalmente
app.use(vMoney, { precision: 2 }); // Adiciona o v-money


// Montando a aplicação
app.mount('#app')
